// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"a1ee3b8d","446":"a1ee3b8d"}[chunkId] + ".chunk.css";
};